export let JOSEError = /*#__PURE__*/(() => {
  class JOSEError extends Error {
    static code = 'ERR_JOSE_GENERIC';
    code = 'ERR_JOSE_GENERIC';
    constructor(message, options) {
      super(message, options);
      this.name = this.constructor.name;
      Error.captureStackTrace?.(this, this.constructor);
    }
  }
  return JOSEError;
})();
export let JWTClaimValidationFailed = /*#__PURE__*/(() => {
  class JWTClaimValidationFailed extends JOSEError {
    static code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
    code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
    claim;
    reason;
    payload;
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified') {
      super(message, {
        cause: {
          claim,
          reason,
          payload
        }
      });
      this.claim = claim;
      this.reason = reason;
      this.payload = payload;
    }
  }
  return JWTClaimValidationFailed;
})();
export let JWTExpired = /*#__PURE__*/(() => {
  class JWTExpired extends JOSEError {
    static code = 'ERR_JWT_EXPIRED';
    code = 'ERR_JWT_EXPIRED';
    claim;
    reason;
    payload;
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified') {
      super(message, {
        cause: {
          claim,
          reason,
          payload
        }
      });
      this.claim = claim;
      this.reason = reason;
      this.payload = payload;
    }
  }
  return JWTExpired;
})();
export let JOSEAlgNotAllowed = /*#__PURE__*/(() => {
  class JOSEAlgNotAllowed extends JOSEError {
    static code = 'ERR_JOSE_ALG_NOT_ALLOWED';
    code = 'ERR_JOSE_ALG_NOT_ALLOWED';
  }
  return JOSEAlgNotAllowed;
})();
export let JOSENotSupported = /*#__PURE__*/(() => {
  class JOSENotSupported extends JOSEError {
    static code = 'ERR_JOSE_NOT_SUPPORTED';
    code = 'ERR_JOSE_NOT_SUPPORTED';
  }
  return JOSENotSupported;
})();
export let JWEDecryptionFailed = /*#__PURE__*/(() => {
  class JWEDecryptionFailed extends JOSEError {
    static code = 'ERR_JWE_DECRYPTION_FAILED';
    code = 'ERR_JWE_DECRYPTION_FAILED';
    constructor(message = 'decryption operation failed', options) {
      super(message, options);
    }
  }
  return JWEDecryptionFailed;
})();
export let JWEInvalid = /*#__PURE__*/(() => {
  class JWEInvalid extends JOSEError {
    static code = 'ERR_JWE_INVALID';
    code = 'ERR_JWE_INVALID';
  }
  return JWEInvalid;
})();
export let JWSInvalid = /*#__PURE__*/(() => {
  class JWSInvalid extends JOSEError {
    static code = 'ERR_JWS_INVALID';
    code = 'ERR_JWS_INVALID';
  }
  return JWSInvalid;
})();
export let JWTInvalid = /*#__PURE__*/(() => {
  class JWTInvalid extends JOSEError {
    static code = 'ERR_JWT_INVALID';
    code = 'ERR_JWT_INVALID';
  }
  return JWTInvalid;
})();
export let JWKInvalid = /*#__PURE__*/(() => {
  class JWKInvalid extends JOSEError {
    static code = 'ERR_JWK_INVALID';
    code = 'ERR_JWK_INVALID';
  }
  return JWKInvalid;
})();
export let JWKSInvalid = /*#__PURE__*/(() => {
  class JWKSInvalid extends JOSEError {
    static code = 'ERR_JWKS_INVALID';
    code = 'ERR_JWKS_INVALID';
  }
  return JWKSInvalid;
})();
export let JWKSNoMatchingKey = /*#__PURE__*/(() => {
  class JWKSNoMatchingKey extends JOSEError {
    static code = 'ERR_JWKS_NO_MATCHING_KEY';
    code = 'ERR_JWKS_NO_MATCHING_KEY';
    constructor(message = 'no applicable key found in the JSON Web Key Set', options) {
      super(message, options);
    }
  }
  return JWKSNoMatchingKey;
})();
export let JWKSMultipleMatchingKeys = /*#__PURE__*/(() => {
  class JWKSMultipleMatchingKeys extends JOSEError {
    [Symbol.asyncIterator];
    static code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    constructor(message = 'multiple matching keys found in the JSON Web Key Set', options) {
      super(message, options);
    }
  }
  return JWKSMultipleMatchingKeys;
})();
export let JWKSTimeout = /*#__PURE__*/(() => {
  class JWKSTimeout extends JOSEError {
    static code = 'ERR_JWKS_TIMEOUT';
    code = 'ERR_JWKS_TIMEOUT';
    constructor(message = 'request timed out', options) {
      super(message, options);
    }
  }
  return JWKSTimeout;
})();
export let JWSSignatureVerificationFailed = /*#__PURE__*/(() => {
  class JWSSignatureVerificationFailed extends JOSEError {
    static code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    constructor(message = 'signature verification failed', options) {
      super(message, options);
    }
  }
  return JWSSignatureVerificationFailed;
})();